module.exports = "pegasus/assets/blocks/header-5-theme3.png";